import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
type HrModalProps = {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'md' | 'lg' | 'xl';
};
const widths = {
  md: 'max-w-lg',
  lg: 'max-w-3xl',
  xl: 'max-w-5xl'
};

/** Accessible dialog shell used across HR & Payroll (Escape + close button). */
export function HrModal({
  title,
  subtitle,
  onClose,
  children,
  footer,
  size = 'md'
}: HrModalProps) {
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    panelRef.current?.focus();
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4" role="dialog" aria-modal="true" aria-labelledby="hr-modal-title" data-id="element-932" data-mp="2m4j5kypc7hpu">
      <div ref={panelRef} tabIndex={-1} className={`flex max-h-[92vh] w-full ${widths[size]} flex-col overflow-hidden rounded-xl bg-white shadow-2xl focus:outline-none`} data-id="element-933" data-mp="2i51yk0u9icik">
        <header className="flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" data-id="element-934" data-mp="1qqpko927igxw">
          <div className="min-w-0" data-id="element-935" data-mp="1crg252qj3aqr">
            <h2 id="hr-modal-title" className="text-lg font-bold text-slate-900" data-id="element-936" data-mp="1gt1e8lv8nkzw">{title}</h2>
            {subtitle && <p className="text-sm text-slate-500" data-id="element-937" data-mp="131ehkkxdwagl">{subtitle}</p>}
          </div>
          <button type="button" onClick={onClose} aria-label="Close" className="rounded-md p-1.5 text-slate-500 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-938" data-mp="17smrrj6jfzut">
            <XIcon className="h-5 w-5" data-id="element-939" data-mp="t1vy05ldyqp2" />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto px-5 py-4" data-id="element-940" data-mp="y3cvdr4nvv0w">{children}</div>
        {footer && <footer className="flex flex-wrap justify-end gap-2 border-t border-slate-200 bg-slate-50 px-5 py-3" data-id="element-941" data-mp="k4d9uscg3w8y">{footer}</footer>}
      </div>
    </div>;
}